export default Object.freeze({
  SPACES: 'spaces',
  PAGES: 'pages',
  // TEMPLATES: 'templates',
});
